import { toolBtn } from "@/ui/toolBtn.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import { changeTheme } from "@/core/changeTheme.js";
import { soundsChange } from "@/core/soundsChange.js";
import { setLS } from "@/utils/local-storage.js";

export function themeBtn(parent) {
  const classes = ["theme", "tools__item"];
  const fontAnsomeClasses = ["fa-solid", "fa-palette", "fa-l"];
  changeTheme();
  const elem = toolBtn({
    parent: parent,
    classes: classes,
    fontElemClasses: fontAnsomeClasses,
    onClick: () => eventEmitter.emit("changeTheme"),
  });
  return elem;
}
export function bestBtn(parent) {
  const classes = ["best", "tools__item"];
  const fontAnsomeClasses = ["fa-solid", "fa-trophy", "fa-l"];
  const elem = toolBtn({
    parent: parent,
    classes: classes,
    fontElemClasses: fontAnsomeClasses,
    onClick: () => eventEmitter.emit("showBest"),
  });
  return elem;
}
eventEmitter.on("showBest", () => {
  console.log("TODO showBest function");
});
export function soundsBtn(parent) {
  const classes = ["sounds", "tools__item"];
  const fontAnsomeClasses = ["fa-solid", "fa-music", "fa-l"];
  setLS("sound", "on");
  soundsChange();
  const elem = toolBtn({
    parent: parent,
    classes: classes,
    fontElemClasses: fontAnsomeClasses,
    onClick: () => eventEmitter.emit("soundsChange"),
  });
  return elem;
}
